var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 316.553,
    height: 63.032,
    viewBox: "0 0 316.553 63.032",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-clip"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 316.553,
    height: 63.032,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#logo-clip)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M89.359,171.588l-.438.2c-.208.093-.376-.114-.376-.464v-.737a.923.923,0,0,1,.376-.8l.438-.2c.208-.094.376.114.376.463v.737a.923.923,0,0,1-.376.8",
    transform: "translate(-61.152 -117.108)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M94.27,168.309V167.2a.922.922,0,0,1,.376-.8l.658-.3c.208-.093.376.114.376.464v1.106a.923.923,0,0,1-.376.8l-.658.295c-.208.094-.376-.114-.376-.463",
    transform: "translate(-65.107 -114.705)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M101.71,166.692l-.128.058c-.208.093-.376-.114-.376-.464v-.214a.922.922,0,0,1,.376-.8l.128-.058c.208-.094.376.114.376.463v.214a.923.923,0,0,1-.376.8",
    transform: "translate(-69.897 -114.088)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M107.788,163.968l-.128.058c-.208.093-.376-.114-.376-.464v-.214a.922.922,0,0,1,.376-.8l.128-.058c.208-.094.376.114.376.463v.214a.923.923,0,0,1-.376.8",
    transform: "translate(-74.095 -112.206)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M113.583,160.429l-.591.265c-.208.093-.376-.114-.376-.464v-.992a.923.923,0,0,1,.376-.8l.591-.265c.208-.094.376.114.376.463v.992a.923.923,0,0,1-.376.8",
    transform: "translate(-77.776 -109.225)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M119.615,157.566l-.671.3c-.208.093-.376-.114-.376-.464v-1.127a.922.922,0,0,1,.376-.8l.671-.3c.208-.094.376.114.376.463v1.127a.923.923,0,0,1-.376.8",
    transform: "translate(-81.888 -107.155)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M131.821,152.251l-.6.269c-.208.093-.376-.114-.376-.464v-1.006a.923.923,0,0,1,.376-.8l.6-.269c.208-.093.376.114.376.464v1.006a.923.923,0,0,1-.376.8",
    transform: "translate(-90.367 -103.567)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M89.129,160.737l-.805.36c-.208.094-.376-.114-.376-.463v-1.351a.923.923,0,0,1,.376-.8l.805-.36c.208-.094.376.114.376.463v1.351a.923.923,0,0,1-.376.8",
    transform: "translate(-60.74 -109.19)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M95.262,158.146l-.727.326c-.208.094-.376-.114-.376-.463v-1.222a.922.922,0,0,1,.376-.8l.727-.326c.208-.093.376.114.376.463v1.222a.923.923,0,0,1-.376.8",
    transform: "translate(-65.03 -107.489)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M101.486,155.834l-.495.221c-.208.094-.376-.114-.376-.463v-.832a.923.923,0,0,1,.376-.8l.495-.222c.208-.093.376.114.376.464v.832a.923.923,0,0,1-.376.8",
    transform: "translate(-69.489 -106.162)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M107.654,153.372l-.348.156c-.207.093-.376-.114-.376-.464v-.585a.925.925,0,0,1,.376-.8l.348-.156c.208-.093.376.114.376.464v.585a.924.924,0,0,1-.376.8",
    transform: "translate(-73.85 -104.632)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M113.387,149.659l-.91.407c-.208.093-.376-.114-.376-.464v-1.528a.923.923,0,0,1,.376-.8l.91-.407c.208-.094.376.114.376.463v1.528a.923.923,0,0,1-.376.8",
    transform: "translate(-77.421 -101.417)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M119.532,147.115l-.81.362c-.208.094-.376-.114-.376-.463v-1.359a.923.923,0,0,1,.376-.8l.81-.362c.208-.093.376.114.376.464v1.359a.923.923,0,0,1-.376.8",
    transform: "translate(-81.734 -99.776)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M126.048,145.636l-.1.047c-.207.094-.376-.114-.376-.463v-.173a.924.924,0,0,1,.376-.8l.1-.047c.208-.094.376.114.376.463v.173a.924.924,0,0,1-.376.8",
    transform: "translate(-86.723 -99.574)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M131.639,141.527l-.891.4c-.208.094-.376-.114-.376-.463v-1.5a.923.923,0,0,1,.376-.8l.891-.4c.208-.093.376.114.376.464v1.5a.923.923,0,0,1-.376.8",
    transform: "translate(-90.04 -95.822)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M89.091,150.41l-.872.39c-.208.094-.376-.114-.376-.463v-1.465a.923.923,0,0,1,.376-.8l.872-.39c.208-.093.376.114.376.464v1.465a.923.923,0,0,1-.376.8",
    transform: "translate(-60.667 -101.978)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M95.736,146.484v.946a.923.923,0,0,1-.376.8l-.563.253c-.208.094-.376-.114-.376-.463v-.946a.923.923,0,0,1,.376-.8l.563-.253c.208-.094.376.114.376.463",
    transform: "translate(-65.211 -100.832)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M101.394,145.38l-.635.284c-.208.094-.376-.114-.376-.463v-1.066a.923.923,0,0,1,.376-.8l.635-.284c.208-.094.376.114.376.463v1.066a.923.923,0,0,1-.376.8",
    transform: "translate(-69.328 -98.78)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M107.6,143.01l-.435.2c-.208.093-.376-.114-.376-.464v-.73a.923.923,0,0,1,.376-.8l.435-.2c.208-.093.376.114.376.463v.73a.923.923,0,0,1-.376.8",
    transform: "translate(-73.753 -97.376)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M114.01,138.5v.857a.923.923,0,0,1-.376.8l-.51.228c-.208.093-.376-.114-.376-.464v-.857a.923.923,0,0,1,.376-.8l.51-.228c.208-.094.376.114.376.463",
    transform: "translate(-77.867 -95.317)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M119.452,136.68l-.936.42c-.208.094-.376-.114-.376-.463v-1.573a.923.923,0,0,1,.376-.8l.936-.42c.208-.093.376.114.376.463v1.573a.923.923,0,0,1-.376.8",
    transform: "translate(-81.592 -92.422)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M125.876,134.941l-.379.17c-.208.094-.376-.114-.376-.463v-.637a.923.923,0,0,1,.376-.8l.379-.17c.208-.094.376.114.376.463v.637a.923.923,0,0,1-.376.8",
    transform: "translate(-86.413 -91.868)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M130.665,131.488V130.3a.923.923,0,0,1,.376-.8l.71-.318c.208-.093.376.114.376.463v1.192a.923.923,0,0,1-.376.8l-.71.318c-.208.094-.376-.114-.376-.463",
    transform: "translate(-90.242 -89.199)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M88.282,140.479v-1.01a.922.922,0,0,1,.376-.8l.6-.27c.208-.094.376.114.376.463v1.01a.923.923,0,0,1-.376.8l-.6.27c-.208.094-.376-.114-.376-.463",
    transform: "translate(-60.971 -95.568)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M95.017,137.785l-.772.346c-.184.083-.332-.1-.332-.409v-1.3a.816.816,0,0,1,.332-.707l.772-.346c.184-.083.332.1.332.409v1.3a.815.815,0,0,1-.332.707",
    transform: "translate(-64.859 -93.479)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M101.379,135.118l-.665.3c-.208.094-.376-.114-.376-.463v-1.116a.923.923,0,0,1,.376-.8l.665-.3c.208-.093.376.114.376.463v1.116a.924.924,0,0,1-.376.8",
    transform: "translate(-69.297 -91.659)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M107.388,132.2l-.777.348c-.208.094-.376-.114-.376-.463v-1.3a.923.923,0,0,1,.376-.8l.777-.348c.207-.094.376.114.376.463v1.3a.924.924,0,0,1-.376.8",
    transform: "translate(-73.37 -89.513)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M113.371,129.194l-.94.421c-.208.094-.376-.114-.376-.463v-1.578a.923.923,0,0,1,.376-.8l.94-.421c.208-.093.376.114.376.463v1.578A.923.923,0,0,1,113.371,129.194Z",
    transform: "translate(-77.39 -87.248)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M119.936,124.707v1.278a.923.923,0,0,1-.376.8l-.761.34c-.208.093-.376-.114-.376-.463v-1.278a.922.922,0,0,1,.376-.8l.761-.34c.208-.094.376.114.376.463",
    transform: "translate(-81.787 -85.792)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M125.692,124.195l-.683.306c-.208.093-.376-.114-.376-.463v-1.149a.923.923,0,0,1,.376-.8l.683-.306c.208-.093.376.114.376.464v1.148A.923.923,0,0,1,125.692,124.195Z",
    transform: "translate(-86.076 -84.092)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M130.944,119.11l.771-.345c.207-.093.376.114.376.463v1.294a.924.924,0,0,1-.376.8l-.771.345c-.208.093-.376-.114-.376-.463v-1.294a.923.923,0,0,1,.376-.8",
    transform: "translate(-90.175 -82.008)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M95.611,199.985l-.157.07c-.208.094-.376-.114-.376-.463v-.265a.923.923,0,0,1,.376-.8l.157-.07c.208-.093.376.114.376.464v.265a.923.923,0,0,1-.376.8",
    transform: "translate(-65.664 -137.046)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M119.867,188.913l-.262.117c-.208.094-.376-.114-.376-.463v-.441a.923.923,0,0,1,.376-.8l.262-.117c.208-.093.376.114.376.464v.441a.923.923,0,0,1-.376.8",
    transform: "translate(-82.344 -129.277)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M95.514,189.5l-.318.142c-.208.094-.376-.114-.376-.463v-.535a.923.923,0,0,1,.376-.8l.318-.142c.208-.094.376.114.376.463v.535a.923.923,0,0,1-.376.8",
    transform: "translate(-65.486 -129.615)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M113.622,180.948l-.534.239c-.208.093-.376-.114-.376-.463v-.9a.923.923,0,0,1,.376-.8l.534-.239c.208-.094.376.114.376.463v.9a.923.923,0,0,1-.376.8",
    transform: "translate(-77.843 -123.463)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M119.746,178.349l-.463.208c-.208.094-.376-.114-.376-.463v-.779a.923.923,0,0,1,.376-.8l.463-.208c.208-.094.376.114.376.463v.779a.923.923,0,0,1-.376.8",
    transform: "translate(-82.121 -121.749)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M95.234,178.5l-.766.343c-.208.093-.376-.114-.376-.463v-1.286a.923.923,0,0,1,.376-.8l.766-.343c.208-.093.376.114.376.464V177.7a.923.923,0,0,1-.376.8",
    transform: "translate(-64.984 -121.501)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M108.162,174.7c-.134.061-.243-.073-.243-.3a.6.6,0,0,1,.243-.518c.134-.061.243.073.243.3a.6.6,0,0,1-.243.518",
    transform: "translate(-74.533 -120.077)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M114,169.057v.889a.923.923,0,0,1-.376.8l-.529.237c-.208.093-.376-.114-.376-.463v-.89a.922.922,0,0,1,.376-.8l.529-.237c.208-.094.376.114.376.463",
    transform: "translate(-77.85 -116.422)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M119.629,167.809l-.654.293c-.208.094-.376-.114-.376-.463v-1.1a.923.923,0,0,1,.376-.8l.654-.293c.208-.094.376.114.376.463v1.1a.923.923,0,0,1-.376.8",
    transform: "translate(-81.909 -114.248)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M131.876,162.622l-.507.226c-.208.094-.376-.114-.376-.463v-.85a.923.923,0,0,1,.376-.8l.507-.226c.208-.094.376.114.376.463v.85a.923.923,0,0,1-.376.8",
    transform: "translate(-90.469 -110.837)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M88.681,128.441l.729-.326c.181-.081.328.1.328.4v1.222a.8.8,0,0,1-.328.7l-.729.326c-.181.081-.328-.1-.328-.4v-1.222a.8.8,0,0,1,.328-.7",
    transform: "translate(-61.02 -88.467)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M95.038,128.094l-.755.339c-.169.075-.306-.094-.306-.376v-1.269a.752.752,0,0,1,.306-.651l.755-.338c.169-.075.306.093.306.376v1.269A.751.751,0,0,1,95.038,128.094Z",
    transform: "translate(-64.904 -86.869)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M107.71,121.4l-.8.359c-.176.078-.318-.1-.318-.392v-1.348a.781.781,0,0,1,.318-.677l.8-.359c.176-.078.318.1.318.392v1.349a.781.781,0,0,1-.318.677",
    transform: "translate(-73.614 -82.16)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M113.594,117.312v1.3a.821.821,0,0,1-.334.712l-.774.346c-.184.083-.334-.1-.334-.412v-1.3a.821.821,0,0,1,.334-.712l.774-.346c.184-.083.334.1.334.412",
    transform: "translate(-77.457 -80.722)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M125.736,114.645l-.8.359c-.178.079-.323-.1-.323-.4v-1.348a.8.8,0,0,1,.323-.688l.8-.359c.178-.08.323.1.323.4v1.348A.8.8,0,0,1,125.736,114.645Z",
    transform: "translate(-86.061 -77.484)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M132.056,111.621l-.83.372c-.187.084-.338-.1-.338-.417v-1.4a.827.827,0,0,1,.338-.719l.83-.372c.187-.084.339.1.339.417v1.4a.827.827,0,0,1-.339.719",
    transform: "translate(-90.396 -75.328)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M88.883,118.689l.738-.331c.181-.081.328.1.328.4V120a.8.8,0,0,1-.328.7l-.738.331c-.181.081-.328-.1-.328-.4v-1.239a.8.8,0,0,1,.328-.7",
    transform: "translate(-61.16 -81.73)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M95.206,116.2v1.337a.8.8,0,0,1-.328.7l-.8.356c-.181.081-.328-.1-.328-.4v-1.338a.8.8,0,0,1,.328-.7l.8-.356c.181-.081.328.1.328.4",
    transform: "translate(-64.751 -79.96)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M108.059,110.9v1.266a.779.779,0,0,1-.318.677l-.754.337c-.177.078-.319-.1-.319-.392v-1.266a.779.779,0,0,1,.319-.677l.754-.337c.176-.078.318.1.318.392",
    transform: "translate(-73.669 -76.307)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M113.213,110.111l-.849.379c-.184.083-.334-.1-.334-.412v-1.425a.822.822,0,0,1,.334-.712l.849-.379c.184-.083.334.1.334.412V109.4a.82.82,0,0,1-.334.712",
    transform: "translate(-77.372 -74.273)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M132.413,100.1v1.35a.832.832,0,0,1-.339.721l-.8.36c-.187.084-.339-.1-.339-.417v-1.35a.832.832,0,0,1,.339-.721l.8-.36c.187-.084.339.1.339.417",
    transform: "translate(-90.427 -68.831)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M107.51,101.641l-.827.37c-.17.076-.307-.094-.307-.378v-1.389a.752.752,0,0,1,.307-.652l.827-.37c.17-.076.308.094.308.378v1.389a.751.751,0,0,1-.308.652",
    transform: "translate(-73.467 -68.514)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M131.973,92.01l-.969.434c-.187.084-.338-.1-.338-.417V90.4A.827.827,0,0,1,131,89.68l.969-.434c.187-.084.339.1.339.417v1.628A.827.827,0,0,1,131.973,92.01Z",
    transform: "translate(-90.242 -61.623)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M113.689,88.851l-.779.35c-.155.069-.279-.084-.279-.343V87.548a.681.681,0,0,1,.279-.593l.779-.35c.154-.069.279.084.279.343v1.309a.681.681,0,0,1-.279.593",
    transform: "translate(-77.787 -59.802)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M100.522,45.584v5.053a.922.922,0,0,1-.376.8l-1.128.506c-.208.094-.376-.114-.376-.463V49.585h0v5.053a.924.924,0,0,1-.376.8l-1.128.505c-.208.093-.376-.114-.376-.464V50.428c0-.35-.169-.556-.376-.463l-1.128.505c-.208.094-.376-.114-.376-.463V48.112a.923.923,0,0,1,.376-.8l1.128-.505a.923.923,0,0,0,.376-.8V44.111c0-.35-.169-.556-.376-.463l-1.128.505a.923.923,0,0,0-.376.8v1.895a.924.924,0,0,1-.376.8l-1.128.505a.924.924,0,0,0-.376.8v8.211a.923.923,0,0,1-.376.8l-1.128.506c-.208.093-.376-.114-.376-.464V52.956c0-.349-.169-.555-.376-.464l-3.009,1.347c-.208.093-.376-.114-.376-.463V31.9l15.048-6.737V43.479a.923.923,0,0,1-.376.8l-1.128.506a.923.923,0,0,0-.376.8Z",
    transform: "translate(-60.334 -17.377)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M73.831,171.588l.737.2a.469.469,0,0,0,.632-.464v-.737a.882.882,0,0,0-.632-.8l-.737-.2a.469.469,0,0,0-.632.463v.737a.882.882,0,0,0,.632.8",
    transform: "translate(-50.554 -117.108)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M64.759,168.309V167.2a.882.882,0,0,0-.632-.8l-1.106-.3a.469.469,0,0,0-.632.464v1.106a.882.882,0,0,0,.632.8l1.106.295a.469.469,0,0,0,.632-.463",
    transform: "translate(-43.088 -114.705)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M54.259,166.692l.214.058a.469.469,0,0,0,.632-.464v-.214a.882.882,0,0,0-.632-.8l-.214-.058a.469.469,0,0,0-.632.463v.214a.882.882,0,0,0,.632.8",
    transform: "translate(-37.037 -114.088)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M44.049,163.968l.214.058a.469.469,0,0,0,.632-.464v-.214a.882.882,0,0,0-.632-.8l-.214-.058a.469.469,0,0,0-.632.463v.214a.882.882,0,0,0,.632.8",
    transform: "translate(-29.985 -112.206)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M32.583,160.429l.992.265a.469.469,0,0,0,.632-.464v-.992a.882.882,0,0,0-.632-.8l-.992-.265a.469.469,0,0,0-.632.463v.992a.882.882,0,0,0,.632.8",
    transform: "translate(-22.067 -109.225)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M22.156,157.566l1.125.3a.469.469,0,0,0,.632-.464v-1.127a.882.882,0,0,0-.632-.8l-1.125-.3a.469.469,0,0,0-.632.463v1.127a.882.882,0,0,0,.632.8",
    transform: "translate(-14.865 -107.155)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1.933,152.251l1.007.269a.469.469,0,0,0,.632-.464v-1.006a.882.882,0,0,0-.632-.8l-1.007-.269a.469.469,0,0,0-.632.464v1.006a.882.882,0,0,0,.632.8",
    transform: "translate(-0.899 -103.567)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M72.837,160.737l1.351.36a.469.469,0,0,0,.632-.463v-1.351a.882.882,0,0,0-.632-.8l-1.351-.36a.469.469,0,0,0-.632.463v1.351a.882.882,0,0,0,.632.8",
    transform: "translate(-49.868 -109.19)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M62.839,158.146l1.222.326a.469.469,0,0,0,.632-.463v-1.222a.882.882,0,0,0-.632-.8l-1.222-.326a.469.469,0,0,0-.632.463v1.222a.882.882,0,0,0,.632.8",
    transform: "translate(-42.963 -107.489)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M53.26,155.834l.832.221a.469.469,0,0,0,.632-.463v-.832a.882.882,0,0,0-.632-.8l-.832-.222a.469.469,0,0,0-.632.464v.832a.882.882,0,0,0,.632.8",
    transform: "translate(-36.347 -106.162)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M43.449,153.372l.585.156a.469.469,0,0,0,.632-.464v-.585a.883.883,0,0,0-.632-.8l-.585-.156a.469.469,0,0,0-.632.464v.585a.882.882,0,0,0,.632.8",
    transform: "translate(-29.571 -104.632)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M31.715,149.659l1.528.407a.469.469,0,0,0,.632-.464v-1.528a.882.882,0,0,0-.632-.8l-1.528-.407a.469.469,0,0,0-.632.463v1.528a.883.883,0,0,0,.632.8",
    transform: "translate(-21.467 -101.417)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M21.778,147.115l1.359.362a.469.469,0,0,0,.632-.463v-1.359a.882.882,0,0,0-.632-.8l-1.359-.362a.469.469,0,0,0-.632.464v1.359a.882.882,0,0,0,.632.8",
    transform: "translate(-14.604 -99.776)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M13.485,145.636l.173.047a.469.469,0,0,0,.632-.463v-.173a.882.882,0,0,0-.632-.8l-.173-.047a.469.469,0,0,0-.632.463v.173a.882.882,0,0,0,.632.8",
    transform: "translate(-8.877 -99.574)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1.142,141.527l1.5.4a.469.469,0,0,0,.632-.463v-1.5a.883.883,0,0,0-.632-.8l-1.5-.4a.469.469,0,0,0-.632.464v1.5a.882.882,0,0,0,.632.8",
    transform: "translate(-0.352 -95.822)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M72.651,150.41l1.465.39a.469.469,0,0,0,.632-.463v-1.465a.882.882,0,0,0-.632-.8l-1.465-.39a.469.469,0,0,0-.632.464v1.465a.882.882,0,0,0,.632.8",
    transform: "translate(-49.739 -101.978)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M62.651,146.484v.946a.882.882,0,0,0,.632.8l.946.253a.469.469,0,0,0,.632-.463v-.946a.882.882,0,0,0-.632-.8l-.946-.253a.469.469,0,0,0-.632.463",
    transform: "translate(-43.269 -100.832)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M52.882,145.38l1.066.284a.469.469,0,0,0,.632-.463v-1.066a.882.882,0,0,0-.632-.8l-1.066-.284a.469.469,0,0,0-.632.463v1.066a.882.882,0,0,0,.632.8",
    transform: "translate(-36.086 -98.78)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M43.212,143.01l.73.2a.469.469,0,0,0,.632-.464v-.73a.882.882,0,0,0-.632-.8l-.73-.2a.469.469,0,0,0-.632.463v.73a.882.882,0,0,0,.632.8",
    transform: "translate(-29.407 -97.376)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M32.173,138.5v.857a.882.882,0,0,0,.632.8l.857.228a.469.469,0,0,0,.632-.464v-.857a.882.882,0,0,0-.632-.8l-.857-.228a.469.469,0,0,0-.632.463",
    transform: "translate(-22.22 -95.317)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M21.435,136.68l1.573.42a.469.469,0,0,0,.632-.463v-1.573a.882.882,0,0,0-.632-.8l-1.573-.42a.469.469,0,0,0-.632.463v1.573a.882.882,0,0,0,.632.8",
    transform: "translate(-14.367 -92.422)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M12.738,134.941l.637.17a.468.468,0,0,0,.632-.463v-.637a.882.882,0,0,0-.632-.8l-.637-.17a.469.469,0,0,0-.632.463v.637a.882.882,0,0,0,.632.8",
    transform: "translate(-8.361 -91.868)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M3.455,131.488V130.3a.882.882,0,0,0-.632-.8l-1.192-.318A.469.469,0,0,0,1,129.64v1.192a.882.882,0,0,0,.632.8l1.192.318a.469.469,0,0,0,.632-.463",
    transform: "translate(-0.69 -89.199)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M75.029,140.479v-1.01a.882.882,0,0,0-.632-.8l-1.01-.27a.469.469,0,0,0-.632.463v1.01a.882.882,0,0,0,.632.8l1.01.27a.469.469,0,0,0,.632-.463",
    transform: "translate(-50.247 -95.568)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M63.41,137.785l1.3.346a.414.414,0,0,0,.557-.409v-1.3a.781.781,0,0,0-.557-.707l-1.3-.346a.414.414,0,0,0-.557.409v1.3a.781.781,0,0,0,.557.707",
    transform: "translate(-43.409 -93.479)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M52.8,135.118l1.116.3a.469.469,0,0,0,.632-.463v-1.116a.882.882,0,0,0-.632-.8l-1.116-.3a.469.469,0,0,0-.632.463v1.116a.882.882,0,0,0,.632.8",
    transform: "translate(-36.03 -91.659)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M42.284,132.2l1.3.348a.469.469,0,0,0,.632-.463v-1.3a.882.882,0,0,0-.632-.8l-1.3-.348a.468.468,0,0,0-.632.463v1.3a.882.882,0,0,0,.632.8",
    transform: "translate(-28.767 -89.513)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M31.635,129.194l1.578.421a.469.469,0,0,0,.632-.463v-1.578a.882.882,0,0,0-.632-.8l-1.578-.421a.469.469,0,0,0-.632.463v1.578A.882.882,0,0,0,31.635,129.194Z",
    transform: "translate(-21.412 -87.248)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M21.282,124.707v1.278a.882.882,0,0,0,.632.8l1.278.34a.469.469,0,0,0,.632-.463v-1.278a.882.882,0,0,0-.632-.8l-1.278-.34a.469.469,0,0,0-.632.463",
    transform: "translate(-14.698 -85.792)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M11.911,124.195l1.149.306a.469.469,0,0,0,.632-.463v-1.149a.882.882,0,0,0-.632-.8l-1.149-.306a.469.469,0,0,0-.632.464v1.148A.882.882,0,0,0,11.911,124.195Z",
    transform: "translate(-7.79 -84.092)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M2.763,119.11l-1.294-.345a.469.469,0,0,0-.632.463v1.294a.882.882,0,0,0,.632.8l1.294.345a.469.469,0,0,0,.632-.463v-1.294a.882.882,0,0,0-.632-.8",
    transform: "translate(-0.578 -82.008)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M64.383,199.985l.265.07a.469.469,0,0,0,.632-.463v-.265a.883.883,0,0,0-.632-.8l-.265-.07a.469.469,0,0,0-.632.464v.265a.882.882,0,0,0,.632.8",
    transform: "translate(-44.029 -137.046)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M23.261,188.913l.442.117a.469.469,0,0,0,.632-.463v-.441a.882.882,0,0,0-.632-.8l-.442-.117a.469.469,0,0,0-.632.464v.441a.882.882,0,0,0,.632.8",
    transform: "translate(-15.628 -129.277)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M63.949,189.5l.535.142a.469.469,0,0,0,.632-.463v-.535a.882.882,0,0,0-.632-.8l-.535-.142a.469.469,0,0,0-.632.463v.535a.882.882,0,0,0,.632.8",
    transform: "translate(-43.729 -129.615)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M32.74,180.948l.9.239a.469.469,0,0,0,.632-.463v-.9a.882.882,0,0,0-.632-.8l-.9-.239a.469.469,0,0,0-.632.463v.9a.882.882,0,0,0,.632.8",
    transform: "translate(-22.175 -123.463)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M22.716,178.349l.779.208a.469.469,0,0,0,.632-.463v-.779a.882.882,0,0,0-.632-.8l-.779-.208a.469.469,0,0,0-.632.463v.779a.882.882,0,0,0,.632.8",
    transform: "translate(-15.252 -121.749)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M62.733,178.5l1.286.343a.469.469,0,0,0,.632-.463v-1.286a.882.882,0,0,0-.632-.8l-1.286-.343a.469.469,0,0,0-.632.464V177.7a.882.882,0,0,0,.632.8",
    transform: "translate(-42.889 -121.501)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M44.89,174.7a.3.3,0,0,0,.409-.3.571.571,0,0,0-.409-.518.3.3,0,0,0-.409.3.571.571,0,0,0,.409.518",
    transform: "translate(-30.72 -120.077)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M32.118,169.057v.889a.882.882,0,0,0,.632.8l.889.237a.469.469,0,0,0,.632-.463v-.89a.882.882,0,0,0-.632-.8l-.889-.237a.469.469,0,0,0-.632.463",
    transform: "translate(-22.182 -116.422)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M22.2,167.809l1.1.293a.469.469,0,0,0,.632-.463v-1.1a.882.882,0,0,0-.632-.8l-1.1-.293a.469.469,0,0,0-.632.463v1.1a.882.882,0,0,0,.632.8",
    transform: "translate(-14.897 -114.248)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M2.186,162.622l.85.226a.469.469,0,0,0,.632-.463v-.85a.882.882,0,0,0-.632-.8l-.85-.226a.469.469,0,0,0-.632.463v.85a.882.882,0,0,0,.632.8",
    transform: "translate(-1.073 -110.837)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M74.254,128.441l-1.222-.326a.407.407,0,0,0-.549.4v1.222a.768.768,0,0,0,.549.7l1.222.326a.408.408,0,0,0,.549-.4v-1.222a.767.767,0,0,0-.549-.7",
    transform: "translate(-50.06 -88.467)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M63.639,128.094l1.269.339a.382.382,0,0,0,.514-.376v-1.269a.718.718,0,0,0-.514-.651l-1.269-.338a.381.381,0,0,0-.514.376v1.269A.717.717,0,0,0,63.639,128.094Z",
    transform: "translate(-43.597 -86.869)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M42.081,121.4l1.348.359a.4.4,0,0,0,.536-.392v-1.348a.747.747,0,0,0-.536-.677l-1.348-.359a.4.4,0,0,0-.535.392v1.349a.747.747,0,0,0,.535.677",
    transform: "translate(-28.693 -82.16)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M32.193,117.312v1.3a.784.784,0,0,0,.562.712l1.3.346a.417.417,0,0,0,.562-.412v-1.3a.784.784,0,0,0-.562-.712l-1.3-.346a.417.417,0,0,0-.562.412",
    transform: "translate(-22.234 -80.722)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M11.787,114.645l1.348.359a.4.4,0,0,0,.543-.4v-1.348a.761.761,0,0,0-.543-.688l-1.348-.359a.4.4,0,0,0-.543.4v1.348a.76.76,0,0,0,.543.688",
    transform: "translate(-7.766 -77.484)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M.952,111.621l1.4.372a.422.422,0,0,0,.568-.417v-1.4a.792.792,0,0,0-.568-.719l-1.4-.372a.422.422,0,0,0-.568.417v1.4a.792.792,0,0,0,.568.719",
    transform: "translate(-0.265 -75.328)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M73.872,118.689l-1.239-.331a.407.407,0,0,0-.549.4V120a.767.767,0,0,0,.549.7l1.239.331a.407.407,0,0,0,.549-.4v-1.239a.767.767,0,0,0-.549-.7",
    transform: "translate(-49.784 -81.73)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M63.035,116.2v1.337a.767.767,0,0,0,.549.7l1.337.356a.408.408,0,0,0,.549-.4v-1.338a.767.767,0,0,0-.549-.7l-1.337-.356A.407.407,0,0,0,63.035,116.2Z",
    transform: "translate(-43.534 -79.96)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M41.682,110.9v1.266a.745.745,0,0,0,.535.677l1.266.337a.4.4,0,0,0,.535-.392v-1.266a.745.745,0,0,0-.535-.677l-1.266-.337a.4.4,0,0,0-.535.392",
    transform: "translate(-28.787 -76.307)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M32.553,110.111l1.425.379a.417.417,0,0,0,.562-.412v-1.425a.785.785,0,0,0-.562-.712l-1.425-.379a.417.417,0,0,0-.562.412V109.4a.783.783,0,0,0,.562.712",
    transform: "translate(-22.094 -74.273)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M.454,100.1v1.35a.8.8,0,0,0,.568.721l1.35.36a.422.422,0,0,0,.568-.417v-1.35a.8.8,0,0,0-.568-.721l-1.35-.36a.422.422,0,0,0-.568.417",
    transform: "translate(-0.314 -68.831)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M42.413,101.641l1.389.37a.382.382,0,0,0,.515-.378v-1.389a.72.72,0,0,0-.515-.652l-1.389-.37a.382.382,0,0,0-.515.378v1.389a.721.721,0,0,0,.515.652",
    transform: "translate(-28.936 -68.514)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M.573,92.01l1.628.434a.421.421,0,0,0,.568-.417V90.4A.792.792,0,0,0,2.2,89.68L.573,89.246A.422.422,0,0,0,0,89.663v1.628A.792.792,0,0,0,.573,92.01Z",
    transform: "translate(-0.003 -61.623)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M32.435,88.851l1.308.35a.347.347,0,0,0,.468-.343V87.548a.653.653,0,0,0-.468-.593l-1.308-.35a.347.347,0,0,0-.468.343v1.309a.652.652,0,0,0,.468.593",
    transform: "translate(-22.078 -59.802)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M3.159,45.584v5.053a.882.882,0,0,0,.632.8l1.895.506a.469.469,0,0,0,.632-.463V49.585h0v5.053a.883.883,0,0,0,.632.8l1.895.505a.469.469,0,0,0,.632-.464V50.428a.469.469,0,0,1,.632-.463L12,50.47a.469.469,0,0,0,.632-.463V48.112a.883.883,0,0,0-.632-.8l-1.895-.505a.882.882,0,0,1-.632-.8V44.111a.469.469,0,0,1,.632-.463L12,44.153a.883.883,0,0,1,.632.8v1.895a.882.882,0,0,0,.632.8l1.895.505a.882.882,0,0,1,.632.8v8.211a.882.882,0,0,0,.632.8l1.895.506a.469.469,0,0,0,.632-.464V52.956a.47.47,0,0,1,.632-.464l5.053,1.347a.469.469,0,0,0,.632-.463V31.9L0,25.161V43.479a.882.882,0,0,0,.632.8l1.895.506a.882.882,0,0,1,.632.8Z",
    transform: "translate(0 -17.377)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M28.071,13.087,2.764,6.35,19.546,0,43.082,6.35Z",
    transform: "translate(-1.909 0)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M175.331,52.956h11.475c4.085,0,6.572,2.522,6.572,6.359,0,3.766-2.167,5.187-4.441,5.329v.213a5.437,5.437,0,0,1,5.365,5.791c0,3.979-2.736,7.105-6.395,7.105H175.331Zm4.69,10.338h5.791a2.447,2.447,0,0,0,2.7-2.629v-1.1a2.431,2.431,0,0,0-2.7-2.629h-5.791Zm0,10.48h6.537a2.527,2.527,0,0,0,2.842-2.7V69.866a2.552,2.552,0,0,0-2.842-2.736h-6.537Z",
    transform: "translate(-121.09 -36.573)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M257.939,88.621h-.178a5.031,5.031,0,0,1-5.187,3.517c-3.8,0-5.933-2.629-5.933-7.247V73.167h4.547V84.429c0,2.558.959,3.943,3.126,3.943,1.812,0,3.624-.959,3.624-2.949V73.167h4.547V91.712h-4.547Z",
    transform: "translate(-170.341 -50.532)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M310.374,50.427v-.711c0-1.314.782-2.274,2.665-2.274,1.848,0,2.665.959,2.665,2.274v.711c0,1.314-.817,2.273-2.665,2.273-1.883,0-2.665-.959-2.665-2.273m.391,4.974h4.547V73.946h-4.547Z",
    transform: "translate(-214.356 -32.766)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M344.662,74.422c-3.091,0-4.547-1.634-4.547-4.476V48.133h4.547V70.8h2.451v3.624Z",
    transform: "translate(-234.897 -33.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M379.87,71.331h-.178a5.208,5.208,0,0,1-5.116,3.517c-4.654,0-7.247-3.517-7.247-9.734,0-6.182,2.593-9.663,7.247-9.663a5.106,5.106,0,0,1,5.116,3.482h.178v-10.8h4.547V74.422H379.87Zm0-3.268v-5.9c0-1.812-1.67-2.984-3.837-2.984-2.345,0-3.943,1.741-3.943,4.37v3.2c0,2.629,1.6,4.334,3.943,4.334,2.167,0,3.837-1.1,3.837-3.02",
    transform: "translate(-253.692 -33.243)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M433.817,64.58c0-8.349,4.157-13,10.693-13,4.441,0,7.319,1.883,9.059,5.72l-4.015,2.132a4.908,4.908,0,0,0-5.045-3.7c-3.482,0-5.72,2.523-5.72,6.75v3.908c0,4.263,2.238,6.679,5.72,6.679a5.511,5.511,0,0,0,5.364-3.943l3.8,2.238a9.526,9.526,0,0,1-9.166,5.862c-6.537,0-10.693-4.3-10.693-12.647",
    transform: "translate(-299.611 -35.621)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M502.831,81.452c0-5.933,3.3-9.663,8.6-9.663,5.329,0,8.633,3.73,8.633,9.663,0,5.968-3.3,9.734-8.633,9.734-5.293,0-8.6-3.766-8.6-9.734m12.47,1.741V79.747c0-2.771-1.492-4.3-3.872-4.3-2.345,0-3.837,1.528-3.837,4.3v3.446c0,2.806,1.492,4.334,3.837,4.334,2.38,0,3.872-1.528,3.872-4.334",
    transform: "translate(-347.275 -49.58)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M568.285,90.76V72.215h4.547v3.091h.178a4.947,4.947,0,0,1,4.974-3.517,5.341,5.341,0,0,1,5.364,3.73h.071a5.714,5.714,0,0,1,5.684-3.73c3.624,0,5.684,2.629,5.684,7.247V90.76H590.24V79.5c0-2.665-.959-3.979-2.984-3.979-1.776,0-3.446.995-3.446,2.984V90.76h-4.547V79.5c0-2.665-.959-3.979-2.984-3.979-1.741,0-3.446.995-3.446,2.984V90.76Z",
    transform: "translate(-392.48 -49.58)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M667.039,72.215h4.548V75.27h.142a5.136,5.136,0,0,1,5.116-3.482c4.689,0,7.283,3.482,7.283,9.663,0,6.217-2.593,9.734-7.283,9.734a5.24,5.24,0,0,1-5.116-3.518h-.142v10.2h-4.548Zm12.328,10.871v-3.2c0-2.629-1.634-4.37-3.979-4.37-2.167,0-3.8,1.172-3.8,2.984v5.9c0,1.918,1.634,3.02,3.8,3.02,2.345,0,3.979-1.705,3.979-4.334",
    transform: "translate(-460.683 -49.58)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M737.271,74.422c-3.091,0-4.547-1.634-4.547-4.476V48.133h4.547V70.8h2.451v3.624Z",
    transform: "translate(-506.048 -33.243)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M762.005,50.427v-.711c0-1.314.781-2.274,2.664-2.274,1.847,0,2.664.959,2.664,2.274v.711c0,1.314-.817,2.273-2.664,2.273-1.883,0-2.664-.959-2.664-2.273M762.4,55.4h4.547V73.946H762.4Z",
    transform: "translate(-526.27 -32.766)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M787.5,85.715c0-3.8,2.878-5.684,7.922-5.684h3.162v-1.35c0-2.06-1.03-3.268-3.446-3.268a4.827,4.827,0,0,0-4.228,2.345l-2.7-2.416c1.35-2.131,3.517-3.552,7.247-3.552,5.009,0,7.674,2.38,7.674,6.608v8.739h1.848V90.76h-2.523a3.374,3.374,0,0,1-3.446-3.2h-.213c-.6,2.38-2.629,3.624-5.4,3.624-3.766,0-5.9-2.167-5.9-5.471m11.084-.5V82.766h-2.913c-2.38,0-3.552.817-3.552,2.274v.6c0,1.492,1.03,2.238,2.806,2.238,2.025,0,3.659-.924,3.659-2.665",
    transform: "translate(-543.876 -49.58)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M852.721,90.76V72.215h4.547v3.091h.178a5.116,5.116,0,0,1,5.187-3.517c3.8,0,5.933,2.629,5.933,7.247V90.76h-4.547V79.5c0-2.629-.889-3.979-3.055-3.979-1.883,0-3.7.995-3.7,2.984V90.76Z",
    transform: "translate(-588.923 -49.58)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M913.008,81.452c0-5.933,3.091-9.663,8.562-9.663,3.73,0,6.182,1.776,7.283,4.689l-3.73,1.67a3.462,3.462,0,0,0-3.553-2.7c-2.523,0-3.8,1.776-3.8,4.37v3.375c0,2.593,1.279,4.334,3.8,4.334,2.167,0,3.233-1.244,3.908-2.913l3.482,1.67c-1.208,3.269-3.8,4.9-7.39,4.9-5.471,0-8.562-3.766-8.562-9.734",
    transform: "translate(-630.559 -49.58)",
    fill: "#e761a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M968.127,81.452c0-5.862,3.162-9.663,8.6-9.663,5.791,0,8.455,4.263,8.455,9.343v1.492H972.852v.462a4.119,4.119,0,0,0,4.512,4.476,5.631,5.631,0,0,0,4.725-2.523l2.451,2.736c-1.527,2.1-4.227,3.41-7.673,3.41-5.471,0-8.739-3.8-8.739-9.734m4.725-1.918v.284h7.6V79.5c0-2.558-1.314-4.3-3.659-4.3-2.38,0-3.943,1.776-3.943,4.334",
    transform: "translate(-668.626 -49.58)",
    fill: "#e761a0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.201d310938c6f573b554e59f0fe27c93.svg";
export { ForwardRef as ReactComponent };